module.exports = __webpack_public_path__ + "media/img/pages/career-starter/06-015766a453591df74d30df9a5c129d04.png";